// src/AdminDashboard.jsx

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminDashboard() {
  const [newUsername, setNewUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [status, setStatus] = useState("");
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  const token = localStorage.getItem("admin_token");

  useEffect(() => {
    const checkAdmin = async () => {
      const res = await fetch("https://fastapi-backend-789068808649.us-central1.run.app/auth/me", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (!res.ok || !data.admin) {
        navigate("/admin-login");
      } else {
        fetchUsers();
      }
    };
    checkAdmin();
  }, []);

  const fetchUsers = async () => {
    const res = await fetch("https://fastapi-backend-789068808649.us-central1.run.app/admin/users", {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    if (res.ok) setUsers(data);
  };

  const createUser = async () => {
    const formData = new URLSearchParams();
    formData.append("username", newUsername);
    formData.append("password", newPassword);
    formData.append("is_admin", isAdmin.toString());
    formData.append("token", token);

    const res = await fetch("https://fastapi-backend-789068808649.us-central1.run.app/admin/create-user", {
      method: "POST",
      body: formData,
    });
    const data = await res.json();
    if (res.ok) {
      setStatus("User created successfully");
      setNewUsername(""); setNewPassword(""); setIsAdmin(false);
      fetchUsers();
    } else {
      setStatus(data.detail || "Failed to create user");
    }
  };

  const deleteUser = async (username) => {
    const res = await fetch(`https://fastapi-backend-789068808649.us-central1.run.app/admin/users/${username}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    if (res.ok) fetchUsers();
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.header}>Admin Dashboard</h2>

        <h4>Create New User</h4>
        <input placeholder="Username" value={newUsername} onChange={e => setNewUsername(e.target.value)} style={styles.input} />
        <input placeholder="Password" value={newPassword} onChange={e => setNewPassword(e.target.value)} style={styles.input} />
        <label style={{ display: 'block', marginBottom: '16px' }}>
          <input type="checkbox" checked={isAdmin} onChange={e => setIsAdmin(e.target.checked)} />
          &nbsp;Is Admin?
        </label>
        <button onClick={createUser} style={styles.button}>Create User</button>
        <p style={styles.status}>{status}</p>

        <h4 style={{ marginTop: '40px' }}>Existing Users</h4>
        <table style={{ width: '100%', marginTop: '12px', borderCollapse: 'collapse' }}>
          <thead>
            <tr><th style={styles.th}>Username</th><th style={styles.th}>Admin</th><th style={styles.th}>Actions</th></tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.username}>
                <td style={styles.td}>{user.username}</td>
                <td style={styles.td}>{user.is_admin ? "Yes" : "No"}</td>
                <td style={styles.td}>
                  <button onClick={() => deleteUser(user.username)} style={styles.deleteBtn}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    padding: '60px 20px',
    backgroundColor: '#f4f4f4',
    fontFamily: 'Inter, sans-serif',
    minHeight: '100vh',
  },
  card: {
    background: 'white',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    width: '100%',
    maxWidth: '600px',
  },
  header: {
    fontSize: '26px',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  input: {
    width: '100%',
    padding: '12px',
    marginBottom: '16px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '15px',
  },
  button: {
    padding: '12px 20px',
    fontSize: '16px',
    backgroundColor: '#02AD24',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  status: {
    marginTop: '16px',
    fontWeight: 'bold',
    color: 'green',
  },
  th: {
    textAlign: 'left',
    padding: '8px',
    borderBottom: '1px solid #ddd',
  },
  td: {
    padding: '8px',
    borderBottom: '1px solid #eee',
  },
  deleteBtn: {
    backgroundColor: '#CD0029',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    padding: '6px 12px',
    cursor: 'pointer',
  },
};
